import {Box} from '@mantine/core';
import {ReloadButton} from '@flexinet/ui-components';
import {useContacts} from '../hooks/useContacts';

export const ComponentsReloadButton = () => {
    const {refetchRecords} = useContacts();
    return (
        <Box mx='s'>
            <ReloadButton onClick={() => refetchRecords()}/>
        </Box>
    );
};
